import {gql} from '@apollo/client';

export const CREATE_ACCOUNT_DELIVERY_DRIVER_MUTATION = gql`
    mutation AccountDeliveryDriverMutation($input: AccountDeliveryDriverInput!) {
    createAccountDeliveryDriver(input: $input) {
      id
      email
      phone
      name
      avatarStorageToken
      status
      createdAt
      updatedAt
    }
  }
`;

export interface CreateAccountDeliveryDriverResponse {
  createAccountDeliveryDriver: {
    id: string;
    email?: string | null;
    phone?: string | null;
    name: string;
    avatarStorageToken?: string | null;
    status: number;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
}

export interface CreateAccountDeliveryDriverInput {
  email?: string | null;
  countryCode: number;
  phone?: string | null;
  password: string;
  name: string;
  vehicleTypeId?: string | null;
  vehiclePlate?: string | null;
  avatarStorageToken?: string | null;
  vehicleImageS3KeysJson?: string[] | null;
  vehicleImageUrls?: string[] | null;
  dspCode?: string | null;
  status: number;
  isFromMobile?: boolean | null;
}

export interface CreateAccountDeliveryDriverVariables {
  input: CreateAccountDeliveryDriverInput;
}

export const CHECK_DSP_CODE_EXISTS = gql`
  query CheckDspCodeExists($dspCode: String!) {
    checkDspCodeExists(dspCode: $dspCode)
  }
`;